
const state = {
  id: null,
  campaign_id: undefined,
  document_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
